import styled, { css } from 'styled-components';
import { IconButton } from '@mui/material';
import { CheckCircleOutline, RadioButtonUnchecked } from '@mui/icons-material';

import colors from '../../../../../../../styles/colors';

// min-height, not height: the chip has to grow for the product label's second line.
const Container = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${colors.shades.secondary8};
  min-height: 30px;
  width: auto;
  align-items: center;
  padding: 3px 5px;
  overflow: hidden;
`;

const Title = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
`;

const TitleColumn = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
  cursor: pointer;
`;

// One colour for every product: coach-created products are unbounded, so a
// per-product palette can't be assigned reliably.
const ProductLabel = styled.div`
  font-size: 10px;
  line-height: 12px;
  color: ${colors.shades.secondary6};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const StyledIconButton = styled(IconButton)`
  width: 5px;
  color: ${colors.base.alpha};
  margin-right: 5px;
`;

const radioButtonStyles = css`
  width: 18px;
  height: 18px;
  > path {
    stroke: ${colors.base.primary};
  }
`;

const StyledCheckCircleOutline = styled(CheckCircleOutline)`
  ${radioButtonStyles}
`;

const StyledRadioButtonUnchecked = styled(RadioButtonUnchecked)`
  ${radioButtonStyles}
`;

export {
  Container,
  Title,
  TitleColumn,
  ProductLabel,
  StyledIconButton,
  StyledCheckCircleOutline,
  StyledRadioButtonUnchecked,
};
